export default "__VITE_ASSET__DcHMdLpt__"